import { createContext } from "react"
const StateContext = createContext("state")
export default StateContext
